import type { TOC } from '@ember/component/template-only';
import type { ItemDetailsSignature } from './utils.gts';

/** Card details for persons: biography excerpt */
const PersonDetails: TOC<ItemDetailsSignature> = <template>
  {{#if (knownFor @data)}}
    <p class="text-base-content/60 text-sm">
      {{knownFor @data}}
    </p>
  {{/if}}
  {{#if (bio @data)}}
    <p
      class="text-base-content/70 mt-1 line-clamp-2 min-w-0 text-sm break-words"
    >
      {{bio @data}}
    </p>
  {{/if}}
</template>;

function knownFor(data: Record<string, unknown> | null): string | null {
  const dept = data?.knownForDepartment as string | undefined;
  if (!dept) return null;
  return `Known for: ${dept}`;
}

function bio(data: Record<string, unknown> | null): string | null {
  return (data?.biography as string) ?? (data?.extract as string) ?? null;
}

export default PersonDetails;
